<template>
    <v-container>
      <v-row>
          <v-col cols="12" class="text-center">
            <div class="text-h2">
              {{ $t('about.about_123psy') }}
            </div>
            <div class="font-weight-light">{{ $t('about.a_small_and_easy_to_use_tool') }}</div>
          </v-col>
      </v-row>

      <v-row justify="center">
          <v-col cols="12" md="8" lg="6">
            <v-card class="mt-2">
              <v-card-title>{{ $t('about.what_we_do') }}</v-card-title>
              <v-card-text>
                {{ $t('about.our_application_simplifies') }}
              </v-card-text>
            </v-card>
          </v-col>
      </v-row>

      <v-row justify="center">
          <v-col cols="12" md="8" lg="6">
            <v-card class="mt-2">
              <v-card-title>{{ $t('about.why_we_exist') }}</v-card-title>
              <v-card-text>
                {{ $t('about.paper_based_assessments_are_time_consuming') }}

                {{ $t('about.by_using_digital_assessments') }}
              </v-card-text>
            </v-card>
          </v-col>
      </v-row>

      <v-row justify="center">
          <v-col cols="12" md="8" lg="6">
            <v-card class="mt-2">
              <v-card-title>{{ $t('about.who_we_are') }}</v-card-title>
              <v-card-text>
                <v-container>
                  <v-row>
                    <v-col cols="12" md="4">
                      <div class="text-center mb-4">
                      <v-avatar size="120">
                        <v-img src="images/alex_6.jpg"></v-img>
                      </v-avatar>
                      </div>
                    </v-col>
                    <v-col cols="12" md="8">
                      {{ $t('about.right_now_its_just_me') }}
                      <p/>
                      {{ $t('about.for_me_it_was_natural') }}
                    </v-col>
                  </v-row>
                </v-container>
              </v-card-text>
            </v-card>
          </v-col>
      </v-row>

      <v-row justify="center">
          <v-col cols="12" class="text-center">
            <v-btn to="/" prepend-icon="mdi-arrow-left" variant="text" color="primary">
              {{ $t('about.back_to_home') }}
            </v-btn>
          </v-col>
      </v-row>

    </v-container>
  </template>
  
  <script>
  export default {
    name: 'AboutView'
  }
  </script>
  
  <style scoped>
  </style>